import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ArtworkHelp() {
  const points = ['Logo cleanup available', 'Artwork adjustments available', 'We can work from low-resolution images', 'Fast proof approval process'];
  return <section className="pt-12 pb-24 bg-gray-50" data-id="element-7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-9">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1" data-id="element-10">
            <div className="border-4 border-black p-2 bg-white" data-id="element-11">
              {/* Placeholder photo — swap with a real shot of your design team. */}
              <img src="https://images.unsplash.com/photo-1626785774573-4b799315345d?auto=format&fit=crop&w=900&q=80" alt="A designer preparing custom apparel artwork on a computer" className="w-full h-full object-cover aspect-[4/3]" data-id="element-12" />
            </div>
          </motion.div>

          {/* Copy */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-13">
            <div className="inline-block bg-black text-white px-4 py-1.5 mb-6 font-display font-bold uppercase tracking-widest text-sm" data-id="element-14">
              Artwork Help
            </div>
            <h2 className="text-4xl md:text-5xl font-black uppercase leading-[1.05] mb-6" data-id="element-15">
              Don't Have Artwork? <br className="hidden md:block" data-id="element-16" /> No Problem.
            </h2>
            <p className="text-xl text-gray-600 font-medium mb-8 max-w-xl" data-id="element-17">
              Send us your logo, sketch, screenshot, business card, or even an
              idea — our team can help prepare your artwork for production.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-18">
              {points.map(point => <li key={point} className="flex items-center gap-3" data-id="element-19">
                  <span className="flex-shrink-0 w-7 h-7 bg-black text-white flex items-center justify-center" data-id="element-20">
                    <Check className="w-4 h-4" strokeWidth={3} data-id="element-21" />
                  </span>
                  <span className="text-lg font-bold" data-id="element-22">{point}</span>
                </li>)}
            </ul>

            <motion.button onClick={() => document.getElementById('quote-form')?.scrollIntoView({
            behavior: 'smooth'
          })} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="bg-black text-white px-8 py-4 font-display font-black uppercase tracking-widest text-lg hover:bg-neutral-800 transition-colors" data-id="element-23">
              Send Us Your Idea
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>;
}